export const plans: TableModule = {
    name: "plans",
    route: "spa.system.plans",
    defaultOrder: {
        column: "price_monthly_eur",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true,
        },
        {
            name: "system_code",
            sortable: true
        },
        {
            name: "price_monthly_eur",
            sortable: true,
            mobile: true,
        },
        {
            name: "price_yearly_eur",
            sortable: true,
        },
        {
            name: "status",
        }
    ],
    filters: [
        {
            name: "name",
            column: "name",
            type: "string",
            reduced: true
        },
        {
            name: "system_code",
            column: "system_code",
            type: "string",
            reduced: true
        },
        {
            name: "price_monthly_eur",
            column: "price_monthly_eur",
            type: "numeric",
            reduced: '[,]'
        },
        {
            name: "price_yearly_eur",
            column: "price_yearly_eur",
            type: "numeric",
            reduced: '[,]'
        }
    ],
    quickFilters: [
        {
            name: "onlyActive",
            column: "active",
            operator: "=",
            value: true,
            default: true
        },
        {
            name: "onlyVisible",
            column: "visible",
            operator: "=",
            value: true,
            default: true
        }
    ],
    tools: [
        {
            name: "plans.create",
            isCreateAction: true,
            ability: ["create", "plans"]
        },
        {
            name: "plans.visibility",
            color: "success",
        },
        {
            name: "plans.archive",
            color: "rose",
        },
    ]
}